<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 col-md-6 col-lg-7 mt-5 mb-3 mb-md-5">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mt-md-5 buybox mb-md-5">
            <div v-stick-in-parent>
              <!-- START SINGLEITEM_DETAILS -->
              <p class="addtext mb-0" v-if="currentVariation.texts.name3">{{ currentVariation.texts.name3 }}</p>

              <div class="producertag mb-0 mb-md-3" v-if="currentVariation.filter.hasManufacturer">
                {{ currentVariation.item.manufacturer.externalName }}
              </div>

              <h1 class="h2 title" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
              </h1>

              <div class="d-none">
                <slot name="tag-list"></slot>
              </div>

              <hr v-if="hasProp327Ebike" />

              <div class="testimonial d-flex align-items-center" v-if="hasProp327Ebike">
                <img :src="selectedImage" class="img-fluid mr-3" />
                <p class="mb-0">
                  <em>"{{ currentVariation.texts.shortDescription }}"</em>
                </p>
              </div>

              <hr v-if="hasProp327Ebike" />

              <div class="sizechart mb-2 mt-5" v-if="hasProp327Ebike">
                <span
                  ><b>{{ $translate("KloeppingVueTheme::SingleItem.SizeChartHeadline") }} </b></span
                >
                <a type="button" class="d-inline" data-toggle="modal" data-target="#fs-sizetable" rel="noopener noreferrer">
                  {{ $translate("KloeppingVueTheme::SingleItem.SizeChartText") }}
                </a>
              </div>

              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <!-- Item Bundle -->
              <item-bundle
                v-if="currentVariation.variation.bundleType === 'bundle'"
                :bundle-type="currentVariation.variation.bundleType"
                :bundle-components="currentVariation.bundleComponents"
              ></item-bundle>
              <!-- /Item Bundle -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <graduated-prices></graduated-prices>

              <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

              <slot name="after-price"></slot>

              <slot name="additional-content-after-vat"></slot>

              <div class="fs-availability">
                <item-availability></item-availability>
              </div>

              <div class="mt-3 mb-4 fs-addtobasket">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3 px-0">
                  <add-to-basket
                    :variation-id="currentVariation.variation.id"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :maximum-quantity="
                      !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                    "
                    :order-properties="
                      currentVariation.properties.filter(function(prop) {
                        return prop.property.isOderProperty;
                      })
                    "
                    :has-order-properties="currentVariation.hasOrderProperties"
                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :item-url="currentVariation | itemURL"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :has-price="currentVariation | hasItemDefaultPrice"
                  >
                  </add-to-basket>
                </div>

                <div class="w-100">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <ul class="list-unstyled d-flex flex-wrap partner mb-5 mb-md-0" v-if="hasProp327Ebike">
                <li class="mb-2 mr-2">
                  <a :href="$translate('KloeppingVueTheme::FooterPartner.Partner1Link')">
                    <img :src="$translate('KloeppingVueTheme::FooterPartner.Partner1Icon')" :alt="$translate('KloeppingVueTheme::FooterPartner.Partner1AltText')" class="img-fluid" />
                  </a>
                </li>
                <li class="mb-2 mr-2">
                  <a :href="$translate('KloeppingVueTheme::FooterPartner.Partner2Link')">
                    <img :src="$translate('KloeppingVueTheme::FooterPartner.Partner2Icon')" :alt="$translate('KloeppingVueTheme::FooterPartner.Partner2AltText')" class="img-fluid" />
                  </a>
                </li>
                <li class="mb-2 mr-2">
                  <a :href="$translate('KloeppingVueTheme::FooterPartner.Partner3Link')">
                    <img :src="$translate('KloeppingVueTheme::FooterPartner.Partner3Icon')" :alt="$translate('KloeppingVueTheme::FooterPartner.Partner3AltText')" class="img-fluid" />
                  </a>
                </li>
                <li class="mb-2 mr-2">
                  <a :href="$translate('KloeppingVueTheme::FooterPartner.Partner4Link')">
                    <img :src="$translate('KloeppingVueTheme::FooterPartner.Partner4Icon')" :alt="$translate('KloeppingVueTheme::FooterPartner.Partner4AltText')" class="img-fluid" />
                  </a>
                </li>
              </ul>

              <!-- ./ITEM DETAIL -->
              <slot name="additional-content-after-add-to-basket"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-md-6">
            <p class="h3">{{ $translate("KloeppingVueTheme::SingleItem.DescriptionHeadline") }}</p>
            <div class="my-4" v-html="currentVariation.texts.description"></div>
            <div class="eu-responsible small">
              <p class="h4">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</p>
              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                  {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                </span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
              </div>
            </div>
            <div class="eu-responsible small mt-4">
              <p class="h4">{{ $translate("Ceres::Template.singleItemManufacturer") }}</p>
              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.name }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.legalName }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.street }}</span>
                <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                <span>{{ currentVariation.item.manufacturer.town }}</span>
                <span v-if="currentVariation.item.manufacturer.countryObject">
                  {{ currentVariation.item.manufacturer.countryObject.name }}
                </span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.email }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.url }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
              </div>

              <div class="p-0">
                <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="item-data-container mb-5 mb-md-0">
              <p class="h3">{{ $translate("KloeppingVueTheme::SingleItem.TechnicalDataHeadline") }}</p>
              <div class="item-data">
                <div v-html="currentVariation.texts.technicalData"></div>
              </div>
              <div class="mt-3 text-center">
                <a
                  class="d-inline-block text-muted text-center p-2 btn-more"
                  href="#"
                  onclick="event.preventDefault(); document.getElementsByClassName('item-data-container')[0].classList.toggle('show');"
                >
                  <span class="font-weight-bold show-more">{{ $translate("KloeppingVueTheme::SingleItem.ShowMore") }}</span>
                  <span class="font-weight-bold show-less">{{ $translate("KloeppingVueTheme::SingleItem.ShowLess") }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid single bg-gray py-3 py-md-5" v-if="hasProp327vehicle">
        <div class="container-max">
          <div class="row usps">
            <div class="col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0">
              <lazy-img
                :image-url="$translate('KloeppingVueTheme::SingleItemUSPs.USP1ImgUrl')"
                :picture-alt="$translate('KloeppingVueTheme::SingleItemUSPs.USP1Headline')"
                picture-class="img-fluid"
              ></lazy-img>
              <div class="usp-text ml-3">
                <b>{{ $translate("KloeppingVueTheme::SingleItemUSPs.USP1Headline") }}</b>
                <p class="mb-0" v-html="$translate('KloeppingVueTheme::SingleItemUSPs.USP1Text')"></p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0">
              <lazy-img
                :image-url="$translate('KloeppingVueTheme::SingleItemUSPs.USP2ImgUrl')"
                :picture-alt="$translate('KloeppingVueTheme::SingleItemUSPs.USP2Headline')"
                picture-class="img-fluid"
              ></lazy-img>
              <div class="usp-text ml-3">
                <b>{{ $translate("KloeppingVueTheme::SingleItemUSPs.USP2Headline") }}</b>
                <p class="mb-0" v-html="$translate('KloeppingVueTheme::SingleItemUSPs.USP2Text')"></p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0">
              <lazy-img
                :image-url="$translate('KloeppingVueTheme::SingleItemUSPs.USP3ImgUrl')"
                :picture-alt="$translate('KloeppingVueTheme::SingleItemUSPs.USP3Headline')"
                picture-class="img-fluid"
              ></lazy-img>
              <div class="usp-text ml-3">
                <b>{{ $translate("KloeppingVueTheme::SingleItemUSPs.USP3Headline") }}</b>
                <p class="mb-0" v-html="$translate('KloeppingVueTheme::SingleItemUSPs.USP3Text')"></p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0">
              <lazy-img
                :image-url="$translate('KloeppingVueTheme::SingleItemUSPs.USP4ImgUrl')"
                :picture-alt="$translate('KloeppingVueTheme::SingleItemUSPs.USP4Headline')"
                picture-class="img-fluid"
              ></lazy-img>
              <div class="usp-text ml-3">
                <b>{{ $translate("KloeppingVueTheme::SingleItemUSPs.USP4Headline") }}</b>
                <p class="mb-0" v-html="$translate('KloeppingVueTheme::SingleItemUSPs.USP4Text')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-max mb-5 mb-md-0" v-if="hasProp327vehicle">
        <div class="row my-3 my-md-5">
          <div class="col-12 rts-wrapper">
            <div class="rts-img">
              <picture>
                <source media="(max-width:576px)" :srcset="$translate('KloeppingVueTheme::SingleItemUSPs.RTSMobileImg')" :alt="$translate('KloeppingVueTheme::SingleItemUSPs.RTSHeadline')" />
                <img :src="$translate('KloeppingVueTheme::SingleItemUSPs.RTSDesktopImg')" :alt="$translate('KloeppingVueTheme::SingleItemUSPs.RTSHeadline')" class="img-fluid mx-auto" />
              </picture>
            </div>
            <div class="col-12 col-md-6 offset-md-6" id="rtsSide">
              <p class="h3 text-white">{{ $translate("KloeppingVueTheme::SingleItemUSPs.RTSHeadline") }}</p>
              <p class="text-white">{{ $translate("KloeppingVueTheme::SingleItemUSPs.RTSText") }}</p>
              <a :href="$translate('KloeppingVueTheme::SingleItemUSPs.RTSLink')" class="text-white font-weight-bold"
                >{{ $translate("KloeppingVueTheme::SingleItemUSPs.RTSLinkText") }}<i class="fa fa-arrow-right ml-3" aria-hidden="true"></i
              ></a>
            </div>
          </div>
        </div>
      </div>

      <div class="single container-max page-content">
        <div class="row cross-selling">
          <slot name="cross-selling-accessory"></slot>
          <slot name="cross-selling-similar"></slot>
          <slot name="feedback-container"></slot>
        </div>
      </div>

      <div id="mobile-buybtn">
        <div class="d-flex d-sm-none px-3 align-items-center">
          <div class="vselect mr-3" v-if="attributes.length || Object.keys(units).length">
            <variation-select></variation-select>
          </div>
          <div class="mobile-add">
            <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
              {{ $translate("Ceres::Template.singleItemSetInfo") }}
            </div>
            <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3 px-0">
              <add-to-basket
                :variation-id="currentVariation.variation.id"
                :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                :order-properties="
                  currentVariation.properties.filter(function(prop) {
                    return prop.property.isOderProperty;
                  })
                "
                :has-order-properties="currentVariation.hasOrderProperties"
                :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                :use-large-scale="false"
                :show-quantity="true"
                :item-url="currentVariation | itemURL"
                :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                :has-price="currentVariation | hasItemDefaultPrice"
              >
              </add-to-basket>
            </div>
          </div>
        </div>
      </div>
    </slot>

    <div id="fs-sizetable" aria-hidden="true" class="modal fade sizechart" role="dialog" tabindex="-1" v-if="hasProp327Ebike">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="exampleModalLabel" class="modal-title">{{ $translate("KloeppingVueTheme::SingleItem.SizeChartModalHeadline") }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="size-table"></slot>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal" type="button">{{ $translate("KloeppingVueTheme::SingleItem.SizeChartModalCloseBtn") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  data: function() {
    return {
      images: [
        "https://picsum.photos/50/51",
        "https://picsum.photos/50/52",
        "https://picsum.photos/50/53",
        "https://picsum.photos/50/54",
        "https://picsum.photos/50/55",
        "https://picsum.photos/50/56",
      ],
      selectedImage: null,
    };
  },

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },

    hasProp327Ebike() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 327 && property.values.selectionId == 1) {
              return true;
            } else {
              return false;
            }
          }
        }
        return false;
      }
      return false;
    },

    hasProp327vehicle() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 327) {
              return true;
            } else {
              return false;
            }
          }
        }
        return false;
      }
      return false;
    },

    hasSizeCategoryId() {
      return App.themeConfig.hasSizeCategoryId > 0;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== ""
      );
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    this.selectedImage = this.randomItem(this.images);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    randomItem(items) {
      return items[Math.floor(Math.random() * items.length)];
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
